module.exports = __webpack_public_path__ + "img/11.c4d9c2aa.png";